import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { LoginResponseBodyUserType } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { shopifyGqlClient } from "../../providers/gqlProvider";
import { GENERAL_ROUTES } from "../../routes/routes";
import { clearSnoozeShopifyScopesDialog } from "../../store/slices/appSettings";
import { clearDashboardFilters } from "../../store/slices/dashboardFilters";
import { resetExperience } from "../../store/slices/experiences";
import { clearGlobal } from "../../store/slices/global";
import { resetRedirects } from "../../store/slices/redirects";
import { clearSitewideDashboardFilters } from "../../store/slices/sitewideDashboardFilters";
import { resetUserInterfaces } from "../../store/slices/userInterfaces";
import { resetWidgets } from "../../store/slices/widgets";
import { IgStorage } from "../../utils/igStorage";
import { api } from "../api";
import { organizationsKeys, userKeys } from "../queryKeys";

export const switchOrganization = async (
  token: string,
  orgId: string
): Promise<LoginResponseBodyUserType> => {
  const resp = await api.post<LoginResponseBodyUserType>("/v2/login", {
    token,
    orgId,
  });
  return resp.data;
};
export const useSwitchOrganization = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useMutation<LoginResponseBodyUserType, Error, any, any>({
    mutationKey: [{ scope: "user" }],
    mutationFn: async (body: { token: string; orgId: string }) =>
      switchOrganization(body.token, body.orgId),
    onSuccess: async (data) => {
      dispatch(clearGlobal());
      await shopifyGqlClient.resetStore();

      IgStorage.authToken = data.token;
      dispatch(clearDashboardFilters());
      dispatch(clearSitewideDashboardFilters());
      dispatch(resetExperience());
      dispatch(resetRedirects());
      dispatch(resetUserInterfaces());
      dispatch(resetWidgets());
      dispatch(clearSnoozeShopifyScopesDialog());
      queryClient.clear();
      queryClient.setQueryData(userKeys.all, data);
      queryClient.setQueryData(organizationsKeys.one, {
        org: data.organization,
      });
      navigate(GENERAL_ROUTES.Home);
    },
  });
};
